import React, { useState } from "react"
import { ShadowRoot } from "./ShadowRoot"
import { getIconType, getStandardIcon, getSVGIcon } from "./constants/utils"

export const CollapsibleListItem = ({ title, openStatus, content, contentType, index, openIcon, closeIcon, onClickCallback }) => {
  return <div>
      <details class="collapsible-list-item" open={openStatus} onClick={(event) => {
        if (event.target.tagName === "DIV") {
          return
        }
        onClickCallback(index, event.currentTarget.open)
      }}>
        <summary class={`collapsible-list-item-title ${index === 0 ? "collapsible-list-first-item-title" : ""}`} data-accordion-index={index} tabindex={index} aria-expanded="false" aria-controls={title}>
          <span>
            <h3>{title}</h3>
          </span>
          <span class="collapsible-list-item-title-icon">
            <span class="collapsible-list-opened">{ getIconType(openIcon) === 'svg' ? <img className="m-0" height={"30px"} width={'auto'} src={getSVGIcon(openIcon)} /> : <i aria-hidden="true" class={getStandardIcon(openIcon) || "fa-plus fas"}></i> }</span>
            <span class="collapsible-list-closed">{  getIconType(closeIcon) === 'svg' ? <img className="m-0" height={"30px"} width={'auto'} src={getSVGIcon(closeIcon)} /> : <i aria-hidden="true" class={closeIcon || "fa-minus fas"}></i> }</span>
          </span>
        </summary>
        <div aria-labelledby={title} class="collapsible-list-content">
          {
            contentType === "RICH_TEXT" ? <ShadowRoot><div dangerouslySetInnerHTML={{ __html: content }} ></div></ShadowRoot> : content
          }
        </div>
      </details>
  </div>
}

const CollapsibleList = ({ data, openIcon, closeIcon, autoToggle }) => {
    const [collapsibleListMap, setCollapsibleListMap] = useState({
      0: true
    })
    const setCollapsibleListData = (index, open) => {
      const listObj = { ...collapsibleListMap };
      if (autoToggle) {
        for (let i in listObj) {
          listObj[i] = ""
        }
      }
      listObj[index] = open
      setCollapsibleListMap({
        ...listObj
      })
    }
    return <div>
      {
        data.map((item, itemIndex) => {
          return <CollapsibleListItem onClickCallback={setCollapsibleListData} key={itemIndex} openIcon={openIcon} closeIcon={closeIcon} title={item.name} content={item.value} contentType={item.valueType} index={itemIndex} openStatus={collapsibleListMap[itemIndex]} />
        })
      }
    </div>;
}

export default CollapsibleList;
